module.exports = __webpack_public_path__ + "img/11.edf4724e.jpg";